import { useRouter } from 'next/router';
import { useEffect } from 'react';

import { routes } from 'src/constants/navigation';

export const useRedirectHome = (redirect: boolean) => {
  const router = useRouter();

  useEffect(
    () => {
      if (redirect) {
        // noinspection JSIgnoredPromiseFromCall
        router.replace(routes.home);
      }
    },
    // https://github.com/vercel/next.js/issues/18127
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [redirect],
  );
};
